<template>
    <div class="container footer-menu">
        <div v-if="!isAuth && displayLogin && !isDeactivated" class="button row no-gutters">
            <router-link to="/registration-new" class="col-lg-6 col-xs-12">
                <button type="button" class="btn btn-register">{{ $t('auth.btnRegister') }}</button>
            </router-link>

            <router-link to="/login" class="col-lg-6 col-xs-12">
                <button type="button" class="btn btn-login">{{ $t('auth.btnLogin') }}</button>
            </router-link>
        </div>
        <nav v-if="showMenu" aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" v-if="isLogged">
                    <router-link to="/guide">{{ $t('menu.guide') }}</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/faq">{{ $t('menu.faq') }}</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/terms">{{ $t('menu.terms') }}</router-link>
                </li>
                <li class="breadcrumb-item" v-if="(isLogged && !isChild  && isMembertype === 1200) ||
                    (isLogged && !isChild  && isMembertype === 1210) ||
                    (isLogged && !isChild  && isMembertype === 1220)">
                    <router-link to="/bonus/terms">{{ $t('menu.bonusTerms') }}</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/policy">{{ $t('menu.policy') }}</router-link>
                </li>
                <li class="breadcrumb-item" v-if="!isLogged || (isLogged && !isChild)">
                    <router-link to="/tokushoho">{{ $t('menu.tokushoho') }}</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/company">{{ $t('menu.operating') }}</router-link>
                </li>
                <li class="breadcrumb-item" v-if="isLogged && !isChild">
                    <router-link to="/contact">{{ $t('menu.contact') }}</router-link>
                </li>
                <li class="breadcrumb-item" v-if="isLogged">
                    <router-link to="/news">{{ $t('menu.news') }}</router-link>
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
import AuthUtil from '../../utils/AuthUtil';
import UserService from "../../services/UserService";

export default {
    name: 'footer-menu',

    components: {
    },

    data(){
        return {
            isLogged: false,
            isChild: true,
            isMembertype: 0,
            isDeactivated: false
        }
    },

    props: {
        showMenu: {
            type: Boolean,
            default: true
        },
        isAuth: {
            type: Boolean,
            default: false
        },
        displayLogin: {
            type: Boolean,
            default: true
        },
    },

    async mounted() {
        this.isLogged = AuthUtil.isAuth();
        this.isDeactivateCompleted();

        if (this.isLogged) {
            this.fetchUserFrontendData();
        }
    },

    methods: {
        async fetchUserFrontendData() {
            const data = (await UserService.getUserFrontendData()).data;
            this.isChild = data.is_child;
            this.isMembertype = data.member_type_id;

        },

        isDeactivateCompleted() {
            if (this.$route.name === "deactivateAdvanceComplete" ||
                this.$route.name === "deactivateBasicComplete") {
                this.isDeactivated = true;
            }
        }
    },
}
</script>

<style lang="css">
.footer-menu {
    margin-top: auto;
}
@media only screen and (max-width: 768px) {
    .footer-menu {
        padding-top: 25px;
    }

}
</style>

<style scoped>
.btn-login {
    background-color: #451493 !important;
    position: relative !important;
}

.btn-login:before {
    background: url(./images/icon_01.png) 50% no-repeat !important;
    background-size: contain !important;
    width: 17px !important;
    height: 15px !important;
    top: 38px !important;
}

.btn-register:before {
    background: url(./images/icon_register_white.svg) 50% no-repeat !important;
    background-size: contain !important;
    width: 17px !important;
    height: 15px !important;
    top: 38px !important;
}

@media screen and (max-width: 991px){
    .btn-login:before {
        width: 15.5px;
        height: 14px;
        top: 27px!important;
    }
    .btn-register:before {
        width: 15.5px;
        height: 14px;
        top: 27px!important;
    }
}
</style>
